import { Button, EmptyState } from '@orbind/ui'
import { useState } from 'react'
import { useT } from '../lib/i18n.tsx'
import { PortfolioExplorer, usePortfolioTree } from './PortfolioExplorer.tsx'
import { PortfolioNodeForm } from './PortfolioNodeForm.tsx'
import './portfolio-node.css'

/**
 * PORT-02 — entrada do módulo Portfólio (`/portfolio/tree`).
 *
 * A árvore não é mais uma tela: ela é o explorer permanente do shell
 * (`_shell.html:298-312`). Esta rota continua existindo porque é o destino do
 * rail e dos links antigos — o que ela renderiza no `<main>` é o estado "nada
 * selecionado", enquanto a árvore aparece no painel ao lado.
 */
export function PortfolioTreePage() {
  const t = useT()
  const [criando, setCriando] = useState(false)
  const tree = usePortfolioTree()

  const vazio = !tree.isPending && (tree.data?.nodes.length ?? 0) === 0
  const solucao = (() => {
    const value = t('portfolio_level.solution')
    return value === 'portfolio_level.solution' ? 'Solução' : value
  })()

  return (
    <>
      <PortfolioExplorer onCreate={() => setCriando(true)} />

      <div className="pt-detail">
        {vazio ? (
          <EmptyState
            icon="fas fa-layer-group"
            title="Portfólio vazio"
            description={`Cadastre a primeira ${solucao} para estruturar produtos, módulos, funcionalidades e ações. A hierarquia é fixa e nunca se inverte.`}
            action={
              <Button variant="primary" icon="fas fa-plus" onClick={() => setCriando(true)}>
                Nova {solucao.toLowerCase()}
              </Button>
            }
          />
        ) : (
          <EmptyState
            icon="fas fa-hand-pointer"
            title="Selecione um item no painel"
            description="Escolha um nó da árvore para ver progresso, estrutura, demandas, Itens de Trabalho e atividade."
            action={
              <Button icon="fas fa-plus" onClick={() => setCriando(true)}>
                Nova {solucao.toLowerCase()}
              </Button>
            }
          />
        )}
      </div>

      {/* Na raiz só existe Solução: o "+" do explorer sempre cria uma. */}
      <PortfolioNodeForm
        open={criando}
        onClose={() => setCriando(false)}
        mode="create"
        level="SOLUTION"
        levelLabel={solucao}
        parentId={null}
      />
    </>
  )
}
